import React from 'react'

const BuildNewPlan = (props) => (
  <div className="modal fade in build-plan">
    <div className="modal-dialog">
      <div className="modal-content">
        {/* used in v2 dashboard
     <div className="heade_title ">
      <span>
        <h4 className="gray"> {window.innerWidth > 768 ? 'No Cook Days Set' : 'Create a New Plan'} </h4>
      </span>              
    </div> */}
        <div className="create-plan-popup-box">
          {!props.isMobile ?
            <div className="card-bg text-center">
              <img src="/images/clos.svg" alt="close" onClick={()=>props.closeBuildPopup()}/>
          
              <h4> New Week, New Plan! </h4>
              <p> Let's get you prepped and ready to conquer another week with a healthy meal plan. </p>
              <button type="button" className="btn btn-success create plan" onClick={()=>props.createPlan(props.dayDates)}> 
          Create Plan 
              </button>
            </div>
            :
            <div className="card-bg text-center">
           
              <h4> New Week, New Plan! </h4>
              <p> 
                You can view existing plans and use your grocery list on your phone, 
                but you’ll have to go to your computer or laptop (some tablets also work) to create a new plan.
              </p> 
              <p>
                We’ve made the tough decision to limit the planning experience to larger screens while 
                we continue to develop the product. We will offer this functionality on mobile in the future. 
                To learn more about this decision, provide feedback, or to just say hello… click the link below! 
              </p>
              <button type="button" className="btn btn-success create plan learn-mr"> 
                Learn More
              </button>
            </div>
          
          }
        </div>
      </div>
    </div>
  </div>
)

export default BuildNewPlan


// WEBPACK FOOTER //
// ./src/components/plans/BuildNewPlan.js